// eslint-disable-next-line import/prefer-default-export
export var FULL_MENU_MEDIA_QUERY = '@media (min-width: 821px)';